import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import List from "@material-ui/core/List";
import Collapse from "@material-ui/core/Collapse";
import PropTypes from "prop-types";

import ButtonListItem from "@meetyoo/components/src/components/List/ButtonListItem";
import ExpandableButtonListItem from "@meetyoo/components/src/components/List/ExpandableButtonListItem";

import EuroIcon from "@material-ui/icons/EuroSymbol";
import LedgerEntryIcon from "@material-ui/icons/Bookmarks";
import ReportingIcon from "@material-ui/icons/Assignment";
import KeyboardTabIcon from "@material-ui/icons/KeyboardTab";

import { REPORTING_USERS } from "../../../constants/user";
import {
  BILLING_LEDGER_ENTRIES_PATH,
  BILLING_REPORTINGS_PATH,
  EVENT_BILLING_PATH,
  DOCUMENT_SENDING_ENTRIES,
  BILLING_EVN_CAPS,
} from "../../../constants/router";

const DrawerBillingContent = ({ user, onClickFn }) => {
  const [open, setOpen] = useState(true);

  function handleClick() {
    setOpen(!open);
  }
  return [
    <ExpandableButtonListItem
      key="drawer-billing-ebli"
      title="Billing"
      icon={<EuroIcon />}
      open={open}
      onClickHandler={handleClick}
    />,
    <Collapse key="drawer-oauth-c" in={open} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        <NavLink
          onClick={onClickFn}
          style={{ color: "inherit", textDecoration: "none" }}
          to={BILLING_LEDGER_ENTRIES_PATH}
        >
          <ButtonListItem subItem title="Ledger Entries" icon={<LedgerEntryIcon />} />
        </NavLink>
        <NavLink onClick={onClickFn} style={{ color: "inherit", textDecoration: "none" }} to={EVENT_BILLING_PATH}>
          <ButtonListItem subItem title="Event Billing" icon={<EuroIcon />} />
        </NavLink>
        <NavLink onClick={onClickFn} style={{ color: "inherit", textDecoration: "none" }} to={DOCUMENT_SENDING_ENTRIES}>
          <ButtonListItem subItem title="Belegversandposten" icon={<LedgerEntryIcon />} />
        </NavLink>
        <NavLink onClick={onClickFn} style={{ color: "inherit", textDecoration: "none" }} to={BILLING_EVN_CAPS}>
          <ButtonListItem subItem title="EVN umhängen" icon={<KeyboardTabIcon />} />
        </NavLink>
        {REPORTING_USERS.includes(user) && (
          <NavLink
            onClick={onClickFn}
            style={{ color: "inherit", textDecoration: "none" }}
            to={BILLING_REPORTINGS_PATH}
          >
            <ButtonListItem subItem title="Reportings" icon={<ReportingIcon />} />
          </NavLink>
        )}
      </List>
    </Collapse>,
  ];
};

DrawerBillingContent.defaultProps = {
  user: "",
};

DrawerBillingContent.propTypes = {
  user: PropTypes.string.isRequired,
  onClickFn: PropTypes.func.isRequired,
};

export default DrawerBillingContent;
